import React, { ReactNode } from "react";
import Markdown from "react-markdown";
import { ListItem, List } from "@material-ui/core";
import Fetch from "../services/Fetch";
import snackbarService from "../services/ui-messaging/SnackbarService";
import { H1, H2, H3, H4, H5, H6 } from "../components/Headers";
import Skeleton from "@material-ui/lab/Skeleton";
import getNumberArray from "./getNumberArray";
import styled from "styled-components";

const Heading = (props: { level: number; children: ReactNode }) => {
  const { level } = props;
  switch (level) {
    case 1:
      return <H1 {...props} />;
    case 2:
      return <H2 {...props} />;
    case 3:
      return <H3 {...props} />;
    case 4:
      return <H4 {...props} />;
    case 5:
      return <H5 {...props} />;
    case 6:
    default:
      return <H6 {...props} />;
  }
};

const renderers = () => {
  return {
    // listitem: ListItem, // todo maybe these be pretty someday
    // list: List,
    heading: Heading,
  };
};

const SkeletonHeader = styled(Skeleton)`
  margin-bottom: 20px;
`;

const ParagraphLines = (props: { className?: string }) => {
  const { className } = props;
  const lineHeight = "30px";
  const totalLines = 6;
  return (
    <div className={className}>
      {getNumberArray(totalLines - 1).map(num => (
        <Skeleton key={num} width="100%" height={lineHeight} />
      ))}
      <Skeleton width="35%" height={lineHeight} />
    </div>
  );
};

const Paragraph = styled(ParagraphLines)`
  margin-bottom: 20px;
`;

export default (mdPath: string, paragraphs: number = 5) => {
  const [content, setContent] = React.useState<string | undefined>();

  React.useEffect(() => {
    const getDoc = async () => {
      try {
        const resp = await Fetch(mdPath);
        const text = await resp.text();
        setContent(text);
      } catch (err) {
        snackbarService.error(err);
      }
    };
    getDoc();
  }, []);

  return content ? (
    <Markdown children={content} />
  ) : (
    <>
      <SkeletonHeader width="100%" height="60px" />
      {getNumberArray(paragraphs).map(num => (
        <Paragraph key={num} />
      ))}
    </>
  );
};
